import store from "../../store";
import MakePayment from "../logic/MakePayment";
import DistanceFormatter from "../logic/DistanceFormatter";

/* Scheduling new order */
// 1. Add locs
export async function addLocs(fromLoc, toLoc) {
  await store
    .dispatch("makeFetch", {
      method: "post",
      body: { locations: [fromLoc, toLoc] },
      goTo: "admin/add-locs",
      returnData: true,
    })
    .catch(() => {
      // console.error("error in adding locs");
      return false;
    });
}

// 2. Calculate distance
export async function calcDistance(fromLoc, toLoc) {
  const distance = await store
    .dispatch("makeFetch", {
      method: "GET",
      goTo: "admin",
      addUrl: `/calc/${fromLoc}_${toLoc}`,
      stateVar: "distance",
      returnData: true,
    })
    .catch(() => {
      // console.error("error in fetching distance");
      return false;
    });

  // console.log(distance);
  return distance;
}

// 3. Use calculated distance and selected vehicle to find cost ie. also finds merchant
export async function calcFee(distanceInfo, vehicle, fromLoc) {
  const body = {
    distance: DistanceFormatter.toKm(
      DistanceFormatter.destructure(distanceInfo)
    ),
    vehicletype: vehicle,
    pickup_location: fromLoc,
  };

  const fee = await store
    .dispatch("makeFetch", {
      method: "post",
      goTo: "admin",
      addUrl: `/calc/fee`,
      body,
      stateVar: "cost",
      returnData: true,
    })
    .catch(() => {
      // console.error("error in fetching cost");
      return false;
    });

  // console.log(fee);
  return fee;
}

// Find rider
export async function findRider(vehicle, distanceInfo, fromLoc) {
  const rider = await store
    .dispatch("makeFetch", {
      method: "post",
      goTo: "admin",
      addUrl: `/select-rider/${vehicle}`,
      body: {
        distance: DistanceFormatter.toKm(
          DistanceFormatter.destructure(distanceInfo)
        ),
        pickup_location: fromLoc,
      },
      stateVar: "rider",
      returnData: true,
    })
    .catch(() => {
      // console.error("error in fetching rider");
      return false;
    });

  // console.log(rider);
  return rider;
}

// 4. Create order
export async function makeOrder(order) {
  const response = await store
    .dispatch("makeFetch", {
      method: "POST",
      body: order,
      withId: true,
      addUrl: "/make-order",
      returnData: true,
    })
    .catch(() => {
      // console.log("error in making order");
      return false;
    });

  // console.log(response);
  return response;
}

// 5. If order is created successfully,
// 5a. Use orderid, standby merchants in calc cost info to get transaction id
export async function initTransact(fee, order) {
  const transaction = await store
    .dispatch("makeFetch", {
      method: "post",
      goTo: "auth",
      addUrl: `/transact/${order.orderid}`,
      body: { standbyMerchants: fee.standbyMerchants },
      returnData: true,
    })
    .catch(() => {
      // console.log("error in starting transaction");
      return false;
    });
  // console.log(transaction);
  return transaction;
}

// 5b. Use transaction id, calc amount, merchant id, totalcost and order to make payment
export function initCheckout(transaction, fee, order) {
  const amount = parseFloat(fee.charge).toFixed(2);
  MakePayment({
    amount,
    order,
    transactionId: `${transaction.transactionId};${fee.merchantId};${amount};${fee.riderId}`,
  });
}

/* Making payment from summary page */
// 1. Add locs
// 2. Calculated distance
// 3. Calculate fee and also find merchant
// 4. Get transaction id
// 5. Make payment.
